import React from 'react';
import posthog from 'posthog-js';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { MantineProvider, Badge, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { PostHogProvider } from '@posthog/react';

import App from './App';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './assets/styles/index.scss';

// hardcoding of token is intended.
// quote posthog: Write-only key for use in client libraries.
// Safe to use in public apps.
posthog.init('phc_9mgHMuAZmze1S4vEl0aKvziR2KPtEqOV7XkVbzu2Alv', {
  api_host: 'https://us.i.posthog.com',

  //  If the special string history_change is provided,
  // PostHog will capture pageviews based on path changes by
  // listening to the browser's history API which is useful
  // for single page apps.
  capture_pageview: 'history_change',
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60000,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const theme = createTheme({
  primaryColor: 'kt-blue',
  colors: {
    'kt-blue': [
      '#B0F2FB',
      '#9DEFFA',
      '#76E8F9',
      '#4FE2F7',
      '#28DBF5',
      '#0BCDE9',
      '#09ABC2',
      '#077C8C',
      '#044C57',
      '#021D21',
    ],
  },
  components: {
    Badge: Badge.extend({
      styles: {
        label: {
          textTransform: 'none',
          fontWeight: 'normal',
        },
      },
    }),
  },
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <Notifications position="bottom-center" zIndex={1000} />
        <PostHogProvider client={posthog}>
          <App />
        </PostHogProvider>
      </MantineProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
);
